<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><span epub:type="pagebreak" id="pageii" title="ii"></span><a href="#/Text/Contents#ded"><span class="blue">Dedication</span></a></p>
<p class="ded_ded_only"><span epub:type="pagebreak" id="pageiii" title="iii"></span>For Dashiell and Strummer,<br/>who make every day special</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?64e33936